export default __webpack_public_path__ + "static/2-6d060d288f8d47f396199fe560e1a47c.png";